/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// TABS


  if (window.jQuery) {
  jQuery(function($) {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });
  }


// SWATCHES

  if (window.jQuery) {
  jQuery(function($) {
    
    $('.swatch-item').hover(function(){
    	$('.swatch-text', this).show();
    },function(){
    $('.swatch-text', this).hide();
    });
    
    
  });
  }

// Elite PDP option popover keyboard support
(function() {
  var productSelector = '.Product[data-product-handle="lash-brow-enhancing-serum-elite"]';
  var formSelector = productSelector + ' .ProductForm';
  var popoverSelector = productSelector + ' .Product__OffScreen .OptionSelector';
  var valueSelector = '.Popover__Value';
  var desktopQuery = window.matchMedia('screen and (min-width: 1008px)');

  function getValues(popover) {
    return Array.prototype.slice.call(popover.querySelectorAll(valueSelector));
  }

  function focusValue(popover, index) {
    var values = getValues(popover);
    if (!values.length) return;

    var boundedIndex = (index + values.length) % values.length;
    values.forEach(function(value) {
      value.classList.remove('is-keyboard-focus');
    });
    values[boundedIndex].classList.add('is-keyboard-focus');
    values[boundedIndex].focus();
  }

  function focusSelectedValue(popover, direction) {
    var values = getValues(popover);
    if (!values.length) return;

    var selectedIndex = values.indexOf(popover.querySelector(valueSelector + '.is-selected'));
    if (selectedIndex < 0) selectedIndex = direction < 0 ? values.length - 1 : 0;
    focusValue(popover, selectedIndex);
  }

  function positionPopover(trigger) {
    if (!desktopQuery.matches || !trigger) return;

    var controls = trigger.getAttribute('aria-controls');
    var popover = controls ? document.getElementById(controls) : null;
    if (!popover || !popover.matches(popoverSelector)) return;

    var gap = 6;
    var triggerRect = trigger.getBoundingClientRect();
    var popoverHeight = popover.offsetHeight;
    var top = triggerRect.bottom + gap;
    var right = Math.max(0, window.innerWidth - triggerRect.right);

    if (top + popoverHeight > window.innerHeight - 12 && triggerRect.top - popoverHeight - gap > 12) {
      top = triggerRect.top - popoverHeight - gap;
      popover.classList.remove('Popover--positionBottom');
      popover.classList.add('Popover--positionTop');
    } else {
      popover.classList.remove('Popover--positionTop', 'Popover--positionLeft', 'Popover--positionCenter');
      popover.classList.add('Popover--positionBottom');
    }

    popover.classList.remove('Popover--alignCenter', 'Popover--alignLeft');
    popover.classList.add('Popover--alignRight');
    popover.style.top = Math.round(top) + 'px';
    popover.style.right = Math.round(right) + 'px';
  }

  function schedulePosition(trigger) {
    [0, 80, 180, 400, 800].forEach(function(delay) {
      window.setTimeout(function() {
        window.requestAnimationFrame(function() {
          positionPopover(trigger);
        });
      }, delay);
    });
  }

  function getTriggerForPopover(popover) {
    var triggers = document.querySelectorAll(formSelector + ' .ProductForm__Item[aria-controls]');

    for (var i = 0; i < triggers.length; i += 1) {
      if (triggers[i].getAttribute('aria-controls') === popover.id) return triggers[i];
    }

    return null;
  }

  function watchElitePopovers() {
    document.querySelectorAll(formSelector + ' .ProductForm__Item[aria-controls]').forEach(function(trigger) {
      if (trigger.getAttribute('data-elite-popover-watch') === 'true') return;

      trigger.setAttribute('data-elite-popover-watch', 'true');
      new MutationObserver(function() {
        if (trigger.getAttribute('aria-expanded') === 'true') schedulePosition(trigger);
      }).observe(trigger, { attributes: true, attributeFilter: ['aria-expanded'] });
    });

    document.querySelectorAll(popoverSelector).forEach(function(popover) {
      if (popover.getAttribute('data-elite-popover-watch') === 'true') return;

      popover.setAttribute('data-elite-popover-watch', 'true');
      new MutationObserver(function() {
        if (popover.getAttribute('aria-hidden') === 'false') schedulePosition(getTriggerForPopover(popover));
      }).observe(popover, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchElitePopovers);
  } else {
    watchElitePopovers();
  }

    document.addEventListener('shopify:section:load', watchElitePopovers);

  document.addEventListener('pointerup', function(event) {
    var trigger = event.target.closest(formSelector + ' .ProductForm__Item[aria-controls]');
    if (trigger) schedulePosition(trigger);
  }, true);

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest(formSelector + ' .ProductForm__Item[aria-controls]');
    if (trigger) schedulePosition(trigger);
  }, true);

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest(formSelector + ' .ProductForm__Item[aria-controls]');
    if (trigger) schedulePosition(trigger);

    if (event.target.closest(popoverSelector + ' ' + valueSelector)) {
      getValues(event.target.closest(popoverSelector)).forEach(function(value) {
        value.classList.remove('is-keyboard-focus');
      });
    }
  });

  document.addEventListener('keyup', function(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var trigger = event.target.closest(formSelector + ' .ProductForm__Item[aria-controls]');
    if (trigger) schedulePosition(trigger);
  });

  window.addEventListener('resize', function() {
    var trigger = document.querySelector(formSelector + ' .ProductForm__Item[aria-expanded="true"][aria-controls]');
    if (trigger) schedulePosition(trigger);
  });

  document.addEventListener('keydown', function(event) {
    var key = event.key;
    var isNext = key === 'ArrowDown' || key === 'ArrowRight';
    var isPrevious = key === 'ArrowUp' || key === 'ArrowLeft';
    var isHome = key === 'Home';
    var isEnd = key === 'End';

    if (!isNext && !isPrevious && !isHome && !isEnd && key !== 'Enter' && key !== ' ') return;

    var target = event.target;
    var popover = target.closest(popoverSelector);

    if (!popover) {
      var form = target.closest(formSelector);
      var controls = target.getAttribute && target.getAttribute('aria-controls');
      popover = form && controls ? document.getElementById(controls) : null;

      if (!popover || !popover.matches('.OptionSelector') || popover.getAttribute('aria-hidden') === 'true') return;
      if (isNext || isPrevious) {
        event.preventDefault();
        positionPopover(target);
        focusSelectedValue(popover, isPrevious ? -1 : 1);
      }

      return;
    }

    if (popover.getAttribute('aria-hidden') === 'true') return;

    var values = getValues(popover);
    var currentIndex = values.indexOf(document.activeElement);

    if (key === 'Enter' || key === ' ') {
      if (currentIndex >= 0) {
        event.preventDefault();
        document.activeElement.click();
      }
      return;
    }

    event.preventDefault();

    if (isHome) focusValue(popover, 0);
    else if (isEnd) focusValue(popover, values.length - 1);
    else if (currentIndex < 0) focusSelectedValue(popover, isPrevious ? -1 : 1);
    else focusValue(popover, currentIndex + (isPrevious ? -1 : 1));
  });
})();

(function() {
  var currencyToMarket = { CAD: 'CA', USD: 'US' };

  function removeRouteInputs(form) {
    var staleInputs = form.querySelectorAll('[data-plume-route]');

    for (var i = 0; i < staleInputs.length; i += 1) {
      staleInputs[i].parentNode.removeChild(staleInputs[i]);
    }
  }

  function addCountryInput(form, countryCode) {
    var input = document.createElement('input');

    input.type = 'hidden';
    input.name = 'country_code';
    input.value = countryCode;
    input.setAttribute('data-plume-route', '1');
    form.appendChild(input);
  }

  function currentMoneyFormatMatchesCurrency(currency) {
    var moneyWithCurrencyFormat = window.theme && window.theme.moneyWithCurrencyFormat;

    return moneyWithCurrencyFormat && moneyWithCurrencyFormat.toUpperCase().indexOf(currency) !== -1;
  }

  function hasEliteUsdPrices() {
    var productRoot = document.querySelector('.Product[data-product-handle="lash-brow-enhancing-serum-elite"]');
    var productJson = document.querySelector('script[data-product-json]');

    if (!productRoot || !productJson) return false;

    try {
      var productData = JSON.parse(productJson.textContent);
      var variants = productData.product && productData.product.variants ? productData.product.variants : [];

      return variants.some(function(variant) {
        return variant.price === 15000 || variant.price === 7900;
      });
    } catch (error) {
      return false;
    }
  }

  function setMarketReturnUrl(form, countryCode) {
    var returnInput = form.querySelector('input[name="return_to"]');

    if (!returnInput || countryCode !== 'CA') return;

    var returnUrl = new URL(window.location.href);
    returnUrl.searchParams.set('plume_market', 'ca');
    returnInput.value = returnUrl.pathname + returnUrl.search;
  }

  function routeSelectedFixedPriceMarket() {
    var select = document.querySelector('.Header__CurrencySelect');

    if (!select) return;

    var selectedCurrency = select.value;
    var expectedCountry = currencyToMarket[selectedCurrency];

    if (!expectedCountry) return;

    var storageKey = 'plume-market-route-asset-' + selectedCurrency + '-' + expectedCountry;
    var hasCadUsdMismatch = selectedCurrency === 'CAD' && hasEliteUsdPrices();

    if (currentMoneyFormatMatchesCurrency(selectedCurrency) && !hasCadUsdMismatch) {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (error) {}

      return;
    }

    try {
      if (window.sessionStorage.getItem(storageKey)) return;
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {}

    var form = select.form || document.getElementById('HeaderCurrencyForm');

    if (!form) return;

    removeRouteInputs(form);
    setMarketReturnUrl(form, expectedCountry);
    addCountryInput(form, expectedCountry);
    form.submit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', routeSelectedFixedPriceMarket);
  } else {
    routeSelectedFixedPriceMarket();
  }
})();
